import request from '../utils/request';

// 互动消息API
export const interactionMessageApi = {
  // 获取互动消息列表（管理员）
  getMessageList: (params) => request.post('/interaction-message/list', params ),

  // 新增互动消息（管理员）
  createMessage: (data) => request.post('/interaction-message', data),

  // 获取消息详情（管理员）
  getMessageDetail: (messageId) => request.get(`/interaction-message/${messageId}`),

  // 批量标记消息为已读
  markMessagesAsRead: (data) => request.put('/interaction-message/mark-read', data),

  // 删除消息
  deleteMessages: (data) => request.delete('/interaction-message/delete', { data }),

  // 获取消息统计信息
  getMessageStatistics: (params) => request.get('/interaction-message/statistics', { params }),

  // 获取不同类型消息的统计
  getMessageTypeStatistics: (params) => request.get('/interaction-message/type-statistics', { params }),

  // 导出消息记录
  exportMessages: (params) => request.get('/interaction-message/export', { 
    params, 
    responseType: 'blob' 
  }),

  // 处理消息（如系统通知的处理）
  processMessage: (data) => request.post('/interaction-message/process', data),

  // 获取消息趋势数据
  getMessageTrendData: (params) => request.get('/interaction-message/trend', { params }),

  // 互动消息统计概览（POST）
  getInteractionStatsOverview: (data) => request.post('/interaction-message/stats/overview', data || {})
}; 